<template>
  <div class="ingrList" ref="defaultIngrList">
    <div
      v-masonry-tile
      v-for="ingredient in ingredientsWithRemoteStorage"
      :key="ingredient.id"
      class="itemBox"
      :class="{ 'display-none': ingredient.hide }"
      @click="change(ingredient, ingredient.count === 1 ? 0 : 1)"
    >
      <div class="infoBlock">
        <div
          class="itemCheckBox"
          v-if="!ingredient.max_count || ingredient.max_count === 1"
        >
          <label class="control control-checkbox">
            <input
              :checked="ingredient.count === 1 || ingredient.selected"
              type="checkbox"
              :disabled="ingredient.soldout"
              @change="change(ingredient, ingredient.count === 1 ? 0 : 1)"
            />
            <div class="control_indicator"></div>
          </label>
        </div>
        <div class="itemName text">
          {{
            getTranslation(
              $store,
              "Ingredient",
              "display_name",
              ingredient.id,
              ingredient.name
            )
          }}
        </div>
        <div class="itemPrice" :class="{ 'display-none': ingredient.soldout }">
          {{ price(ingredient) }}
        </div>
      </div>
      <img
        class="itemImg"
        :src="ingredient.image"
        :style="{ opacity: ingredient.soldout ? 0.12 : 1 }"
      />
    </div>
  </div>
</template>

<script>
import { toPrintable, toCalculatable } from "@/utils/pricing";
import { getTranslation } from "@/utils/helpers";
import { mapGetters } from "vuex";

export default {
  name: "defaultIngredientWidget",
  methods: {
    getTranslation,
    toPrintable,
    toCalculatable,
    change(ingredient, count) {
      if (ingredient.soldout) return;
      this.$emit("change", { ingredient, count });
    },
    price(ing) {
      let ing_price = toCalculatable(ing.price);
      if (ing_price === 0.0) return "";
      return `(${toPrintable(ing_price, true)})`;
    }
  },
  computed: {
    ingredientsWithRemoteStorage() {
      return this.ingredients.map(ingredient => ({
        ...ingredient,
        ...this.itemsDict[ingredient.id]
      }));
    },
    ...mapGetters({
      itemsDict: "ITEMS_DICT"
    })
  },
  props: {
    ingredients: Array
  }
};
</script>

<style scoped>
.ingrList {
  background: var(
    --component_modals_common_defaultIngredientWidget_ingrList_background
  );
  border-radius: var(
    --component_modals_common_defaultIngredientWidget_ingrList_border-radius
  );
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
  margin: var(
    --component_modals_common_defaultIngredientWidget_ingrList_margin
  );
  padding: var(
    --component_modals_common_defaultIngredientWidget_ingrList_padding
  );
}

.itemImg {
  max-height: 63px;
  max-width: 103px;
  position: absolute;
  top: -10px;
  right: 10px;
}

.itemCheckBox {
  height: 30px;
  padding-left: 21px;
}
.itemName {
  margin-left: 45px;
  color: var(--component_modals_common_defaultIngredientWidget_itemName_color);
  font-family: var(--app_font-family_regular);
  font-size: 17px;
  text-align: center;
  font-weight: bold;
  text-transform: var(
    --component_modals_common_defaultIngredientWidget_itemName_text-transform
  );
}
.itemPrice {
  width: 80px;
  height: 30px;
  margin-top: 10px;
  text-align: center;
  color: var(--component_modals_common_defaultIngredientWidget_itemPrice_color);
  font-size: 17px;
  font-family: var(--app_font-family_regular);
}
.itemBox {
  width: var(--component_modals_common_defaultIngredientWidget_itemBox_width);
  height: 53px;
  background: white;
  background: var(
    --component_modals_common_defaultIngredientWidget_itemBox_background
  );
  border-radius: var(
    --component_modals_common_defaultIngredientWidget_itemBox_border
  );
  margin-bottom: var(
    --component_modals_common_defaultIngredientWidget_itemBox_margin-bottom
  );
  align-items: center;
  position: relative;
  display: flex;
}
.infoBlock {
  width: 280px;
  display: flex;
  align-items: center;
}
</style>
